import React from 'react';
import NewVMStep6 from './NewVMStep6';

const NewVMStep6Container = ({ formikProp }) => {
  return <NewVMStep6 formikProp={formikProp} />;
};
export default NewVMStep6Container;
